<template>
  <svg
    class="custom-icon"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.2941 7.7249C16.2353 8.29161 16.2353 9.70839 15.2941 10.2751L6.11765 15.8005C5.17647 16.3673 4 15.6589 4 14.5254L4 3.47456C4 2.34114 5.17647 1.63274 6.11765 2.19946L15.2941 7.7249Z"
    />
  </svg>
</template>
